import WorkOrderItem from "./WorkOrderItem";
import "./wo.css";
import loading from "../../../assets/load.gif";
import ReactPaginate from "react-paginate";

const WorkOrderItems = ({
  ShowWoinfo,
  workOrderListData,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <div className="wo-items-container">
      <div className="divTable wo-items-list">
        {workOrderListData.length !== 0 ? (
          workOrderListData.map((woData, index) => (
            <WorkOrderItem
              key={index}
              WOItem={woData}
              ShowWoinfo={ShowWoinfo}
            />
          ))
        ) : (
          <img src={loading} alt="loading..." className="loadGif loadGiflist" />
        )}
      </div>
      {totalPages > 1 && (
        <div className="wo-pagination-bar">
          <ReactPaginate
            previousLabel="← Föregående"
            nextLabel="Nästa →"
            pageCount={totalPages}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1} // Pages displayed at the edges
            onPageChange={({ selected }) => {
              // Convert from react-paginate's 0-based indexing to 1-based for the API
              onPageChange(selected + 1);
            }}
            containerClassName="pagination"
            activeClassName="active"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            disabledClassName="disabled"
            forcePage={currentPage - 1} // Convert 1-based page to 0-based for react-paginate
            breakClassName="break-item"
          />
        </div>
      )}
    </div>
  );
};

export default WorkOrderItems;
